// Unpublished Work © 2024 Deere & Company.

import {datadogRum, DefaultPrivacyLevel, RumInitConfiguration} from '@datadog/browser-rum';
//@ts-expect-error the datadog-action-logger does not have types exported
import {datadogLogger} from '@deere/datadog-action-logger';
import {beforeSend} from './rum-helper';
import {version} from '../../version';

const ddEnvironments = ['qual', 'cert', 'prod'];

export async function startDatadog(environment: string, userId: string): Promise<void> {
    if (!ddEnvironments.includes(environment)) {
        return;
    }

    const options: RumInitConfiguration = {
        applicationId: 'a6e77761-8d57-49b9-9cae-a0516e5433aa',
        clientToken: 'pub0b3c4c5e7aeaebf9c10917b70384b26c',
        site: 'datadoghq.com',
        service: 'ops-center-router-client',
        env: environment,
        version: `git:${version}`,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 0,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: DefaultPrivacyLevel.MASK_USER_INPUT,
        allowedTracingUrls: [/^https:\/\/[a-zA-Z0-9.-]*\.deere.com/, /^https:\/\/[a-zA-Z0-9.-]*\.johndeerecloud.com/],
        beforeSend
    };

    datadogRum.setGlobalContextProperty('jd_component', 'Ops_Center');
    datadogRum.setUser({
        id: userId
    });

    datadogRum.init(options);
    datadogLogger.setRumInstance(datadogRum);
}
